var React = require('react');

function BtnArrow (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"m0 0 19.892.071.01 2.8-19.892-.071z","transform":"matrix(-.70710678 -.70710678 .70710678 -.70710678 14.073 16.102)","key":0}),React.createElement("path",{"d":"m.01.071 19.89-.071-.01 2.77-19.89.071z","transform":"matrix(-.70710678 .70710678 -.70710678 -.70710678 16.097 13.93)","key":1})]));
}

BtnArrow.defaultProps = {"height":"28","viewBox":"0 0 16.102 28","width":"16.102"};

module.exports = BtnArrow;

BtnArrow.default = BtnArrow;
